(() => {
  // ── Config ─────────────────────────────────────────────────────────────────
  const STATE_KEY = 'collection_inuse_toggle';
  const IS_PRODUCT_PAGE = document.body.classList.contains('template-product');

  // ── Storage ────────────────────────────────────────────────────────────────
  // Auf Product-Detail-Page NICHT persistieren: startet immer OFF, State bleibt
  // nur im JS-Memory bis Page-Unload; jeder Product-Detail startet neu neutral.
  let __memState = false;
  function readState() {
    if (IS_PRODUCT_PAGE) return __memState;
    try { return localStorage.getItem(STATE_KEY) === '1'; } catch { return false; }
  }
  function writeState(val) {
    if (IS_PRODUCT_PAGE) { __memState = !!val; return; }
    try { localStorage.setItem(STATE_KEY, val ? '1' : '0'); } catch {}
  }

  // ── Button UI ──────────────────────────────────────────────────────────────

  function setButtonUI(isOn) {
    // Styling kommt vollständig aus custom.css (html.inuse-mode .inuse-toggle …,
    // mit !important) — hier nur Zustands-Klasse + a11y-State.
    document.querySelectorAll('.inuse-toggle').forEach(btn => {
      btn.classList.toggle('is-active', isOn);
      btn.setAttribute('aria-pressed', String(isOn));
      btn.setAttribute('aria-checked', String(isOn));
    });
  }

  // ── Card image data ────────────────────────────────────────────────────────

  function getInuseSrcs(card) {
    return (card.getAttribute('data-inuse-srcs') || '').split('|').filter(Boolean);
  }

  function packImg(img) {
    return [img.getAttribute('src')||'', img.getAttribute('srcset')||'', img.getAttribute('sizes')||''].join('\x00');
  }

  function applyImgSrc(img, url) {
    img.setAttribute('src',    url);
    img.setAttribute('srcset', `${url} 1066w`);
    img.removeAttribute('sizes');
  }

  function restoreImg(img, packed) {
    const [src, srcset, sizes] = packed.split('\x00');
    if (src)    img.setAttribute('src',    src);
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
    if (sizes)  img.setAttribute('sizes',  sizes);  else img.removeAttribute('sizes');
  }

  // ── Crossfade (div overlay — old image stays visible while new fades in) ──

  function crossfadeCard(card, isOn) {
    const srcs = getInuseSrcs(card);
    if (!srcs.length) return;
    const media = card.querySelector('.card__media .media');
    if (!media) return;
    const imgs = [...media.querySelectorAll('img:not(.inuse-xfade-img)')];
    if (!imgs[0]) return;

    // Remove any pending crossfade overlay
    media.querySelector('.inuse-xfade')?.remove();

    let targetSrc0, targetSrc1;

    if (isOn) {
      if (!card.dataset.inuseOrig0) card.dataset.inuseOrig0 = packImg(imgs[0]);
      if (imgs[1] && !card.dataset.inuseOrig1) card.dataset.inuseOrig1 = packImg(imgs[1]);

      if (!card.dataset.inusePick) {
        card.dataset.inusePick = String(Math.floor(Math.random() * srcs.length));
      }
      const pick = parseInt(card.dataset.inusePick);
      targetSrc0 = srcs[pick];
      targetSrc1 = imgs[1] ? (srcs.length > 1 ? srcs[pick === 0 ? 1 : 0] : srcs[pick]) : null;
    } else {
      if (!card.dataset.inuseOrig0) return;
      targetSrc0 = card.dataset.inuseOrig0.split('\x00')[0];
      targetSrc1 = imgs[1] && card.dataset.inuseOrig1 ? card.dataset.inuseOrig1.split('\x00')[0] : null;
    }

    // Overlay div fades in on top — old image stays fully visible below
    const overlay = document.createElement('div');
    overlay.className = 'inuse-xfade';
    overlay.style.cssText = [
      'position:absolute',
      'inset:0',
      `background:url(${targetSrc0}) center/cover no-repeat`,
      'opacity:0',
      'transition:opacity 0.6s ease',
      'z-index:1',
    ].join(';');
    media.appendChild(overlay);

    requestAnimationFrame(() => requestAnimationFrame(() => {
      overlay.style.opacity = '1';
    }));

    setTimeout(() => {
      // Swap underlying img src, then remove overlay
      if (isOn) {
        applyImgSrc(imgs[0], targetSrc0);
        if (imgs[1] && targetSrc1) applyImgSrc(imgs[1], targetSrc1);
      } else {
        restoreImg(imgs[0], card.dataset.inuseOrig0);
        if (imgs[1] && card.dataset.inuseOrig1) restoreImg(imgs[1], card.dataset.inuseOrig1);
        delete card.dataset.inusePick;
      }
      overlay.remove();
    }, 650);
  }

  function crossfadeGrid(isOn, delay) {
    setTimeout(() => {
      document.querySelectorAll('.product-card-wrapper[data-inuse-srcs]')
        .forEach(card => crossfadeCard(card, isOn));
    }, delay);
  }

  // Instant swap (no animation) — for page init
  function swapCard(card, isOn) {
    const srcs = getInuseSrcs(card);
    if (!srcs.length) return;
    const media = card.querySelector('.card__media .media');
    if (!media) return;
    const imgs = [...media.querySelectorAll('img')];
    if (!imgs[0]) return;

    if (isOn) {
      if (!card.dataset.inuseOrig0) card.dataset.inuseOrig0 = packImg(imgs[0]);
      if (imgs[1] && !card.dataset.inuseOrig1) card.dataset.inuseOrig1 = packImg(imgs[1]);
      if (!card.dataset.inusePick) {
        card.dataset.inusePick = String(Math.floor(Math.random() * srcs.length));
      }
      const pick = parseInt(card.dataset.inusePick);
      applyImgSrc(imgs[0], srcs[pick]);
      if (imgs[1]) {
        const hover = srcs.length > 1 ? srcs[pick === 0 ? 1 : 0] : srcs[pick];
        applyImgSrc(imgs[1], hover);
      }
    } else {
      if (card.dataset.inuseOrig0) restoreImg(imgs[0], card.dataset.inuseOrig0);
      if (imgs[1] && card.dataset.inuseOrig1) restoreImg(imgs[1], card.dataset.inuseOrig1);
      delete card.dataset.inusePick;
    }
  }

  function applyAll() {
    const isOn = readState();
    document.documentElement.classList.toggle('inuse-mode', isOn);
    setButtonUI(isOn);
    document.querySelectorAll('.product-card-wrapper[data-inuse-srcs]')
      .forEach(card => swapCard(card, isOn));
  }

  // ── Click handler ──────────────────────────────────────────────────────────

  function handleClick(e) {
    const btn = e.target.closest('.inuse-toggle');
    if (!btn) return;

    const next = !readState();
    writeState(next);
    document.documentElement.classList.toggle('inuse-mode', next);
    setButtonUI(next);

    // Blur nur die Bild-Container — nicht die ganze Seite.
    // Collection: .product-card-wrapper (nur Card-Bilder).
    // Product:    .product__media-wrapper (nur die Produkt-Galerie).
    const cards = [...document.querySelectorAll('.product-card-wrapper[data-inuse-srcs]')];
    const mediaWrappers = [...document.querySelectorAll('.product__media-wrapper')];

    const blurTargets   = () => {
      cards.forEach(c => c.classList.add('inuse-card-blur'));
      mediaWrappers.forEach(m => m.classList.add('inuse-media-blur'));
    };
    const unblurTargets = (ms) => setTimeout(() => {
      cards.forEach(c => c.classList.remove('inuse-card-blur'));
      mediaWrappers.forEach(m => m.classList.remove('inuse-media-blur'));
    }, ms);

    blurTargets();
    unblurTargets(650);
    crossfadeGrid(next, 280);
  }

  // ── Extern erreichbar: Toggle hart auf OFF setzen ──────────────────────────
  // Wird von product-gallery-inuse-order.js beim Variant-Wechsel gerufen, damit
  // __memState nicht auf true haengen bleibt (sonst braucht der User 2 Klicks).
  window.inuseToggle = window.inuseToggle || {};
  window.inuseToggle.reset = function () {
    writeState(false);
    document.documentElement.classList.remove('inuse-mode');
    setButtonUI(false);
  };

  // ── Init ───────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', () => {
    applyAll();
    document.addEventListener('shopify:section:load', () => applyAll());
  });

  document.addEventListener('click', handleClick);
})();
